import axios from 'axios'
import config from '@/config'
import store from '@/store'
import Router from '../router' 
import { urlMode } from '@/config/baseUrls'
// 创建axios实例
import { getCookie } from '@/utils/cookie'
const service = axios.create({
    // baseURL: config.BASEURL, // api的base_url
    baseURL: '',
    timeout: 40000, // 请求超时时间,
    headers: {
        // "Content-Type": "application/x-www-form-urlencoded"
        "Content-Type": "application/json"
    },
})
function getBaseUrl() {
    if(process.env.NODE_ENV === 'production') {
        if(urlMode == 'list') {
            return window.baseURL
        }
        return config.BASEURL
    }
    return config.BASEURL
}
// request拦截器
service.interceptors.request.use(configs => {
    let lang = configs.url == '/api/app/language' ? 'ENGLISH' : getCookie("lang")
    configs.headers = {
        ...configs.headers,
        "SET-LANGUAGE": lang,
        "APP-LOGIN-TOKEN": getCookie('user-cookie'),
        "APP-ANALOG": getCookie('account-mode'),
        "set-aws":'true'
    }
    configs.baseURL = getBaseUrl();
    return configs;
}, error => {
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        if (response.status == 200) {
            if (response.data.errCode == 100007) {
                if (response.config.url == "/api/app/user/get/info") {
                    return response.data
                } else {
                    store.commit('setUserInfo',{})
                    store.commit('setIsLogin', false)
                    // location.href = '/h5/#/login'
                    Router.push('/login')
                }
            } else {
                return response.data
            }

        }
    },
    async error => {
        return Promise.reject(error)
    }
)




export default service